import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import { Clipart } from 'components/flink-components';
import { Portal } from 'components/common';
import { uploadsURL, filesURL } from 'config';
import { resolveOfflineAssetUrlSync } from 'mobile-modules/offline';
import { getMobileAppPlatform } from 'utils/isMobileAppRuntime';
import classes from './PictureBox.module.scss';

const clipartIcon = `${filesURL}/Images/TemplateGraphics/StoryStudio/clipArtLibrary.png`;

const PictureBox = ({
  paths,
  images = [],
  learnerAssetsList = [],
  onChangeImage,
  onRemoveImage,
  currentImage,
  showList,
  withClipart = false,
  maxImages = 12,
  mobilePhoneLayout = false,
}) => {
  const [showClipart, setShowClipart] = useState(false);
  const iosRuntime = getMobileAppPlatform() === 'ios';
  const shouldResolveOfflineImage = mobilePhoneLayout || iosRuntime;
  const {
    activityAssetsKey,
    activityAssetsFolder,
    learnerAssetsFolder,
  } = paths;

  return (
    <>
      <div
        className={classnames(classes.wrapper, {
          [classes.mobilePhone]: mobilePhoneLayout,
        })}
      >
        {showList && (
          <ul className={classes.list}>
            {_.times(maxImages).map((idx) => {
              const imageFilename = images[idx];
              const key =
                imageFilename && `${activityAssetsKey}/${imageFilename}`;
              const url = key && `${uploadsURL}/${key}`;
              const imageUrl = shouldResolveOfflineImage && url
                ? resolveOfflineAssetUrlSync(url)
                : url;

              return (
                <li key={idx}>
                  {imageFilename && imageFilename !== currentImage && (
                    <button
                      onClick={() => {
                        onChangeImage(imageFilename, key);
                      }}
                    >
                      <img src={imageUrl} alt="" />
                    </button>
                  )}
                  
                  {idx === maxImages - 1 && withClipart && (
                    <button
                      onClick={() => {
                        setShowClipart(true);
                      }}
                    >
                      <img src={clipartIcon} alt="" />
                    </button>
                  )}
                </li>
              );
            })}
          </ul>
        )}

        <div className={classes.currentImageWrapper}>
          {currentImage && (
            <>
              <img
                src={(() => {
                  const currentImageUrl =
                    (learnerAssetsList.includes(currentImage)
                      ? learnerAssetsFolder
                      : activityAssetsFolder) + currentImage;

                  return shouldResolveOfflineImage
                    ? resolveOfflineAssetUrlSync(currentImageUrl)
                    : currentImageUrl;
                })()}
                alt=""
              />
              {showList && (
                <button
                  className={classes.removeImageBtn}
                  onClick={onRemoveImage}
                >
                  &times;
                </button>
              )}
            </>
          )}
        </div>
      </div>

      <Portal>
        <Clipart
          show={showClipart}
          onClose={setShowClipart.bind(null, false)}
          onPick={(fileInfo) => {
            onChangeImage(fileInfo.filename, fileInfo.key, true);
            setShowClipart(false);
          }}
        />
      </Portal>
    </>
  );
};

PictureBox.propTypes = {
  paths: PropTypes.object.isRequired,
  learnerAssetsList: PropTypes.array,
  onChangeImage: PropTypes.func.isRequired,
  onRemoveImage: PropTypes.func.isRequired,
  currentImage: PropTypes.string,
  withClipart: PropTypes.bool,
  images: PropTypes.array,
  maxImages: PropTypes.number,
  mobilePhoneLayout: PropTypes.bool,
};

export default PictureBox;
